import { render, staticRenderFns } from "./TeamSearchJobDetail.vue?vue&type=template&id=1968642e&scoped=true"
import script from "./TeamSearchJobDetail.vue?vue&type=script&lang=js"
export * from "./TeamSearchJobDetail.vue?vue&type=script&lang=js"
import style0 from "./TeamSearchJobDetail.vue?vue&type=style&index=0&id=1968642e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./TeamSearchJobDetail.vue?vue&type=style&index=1&id=1968642e&prod&lang=scss"
import style2 from "./TeamSearchJobDetail.vue?vue&type=style&index=2&id=1968642e&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968642e",
  null
  
)

export default component.exports